export default function generateElementId(prefix: string): string {
    const elementId = `${prefix}-${Math.random().toString(36)}`;
    return elementId;
}
